// extracted by mini-css-extract-plugin
export default {"headingTwoText":"HeadingTwo_headingTwoText__43rdV"};